<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Checkbox, Alert } from '@Shelly/shelly-design-system';
	//Types
	import type { PeripheralInputSettings } from 'src/types/Peripherals';

	let className = '';
	export { className as class };

	export let settings: PeripheralInputSettings;
</script>

<div class={className}>
	{#if settings.enable != null}
		<Checkbox id="enable-input" size="m" bind:checked={settings.enable}
			>{$format('sub_settings_title_enable_input', {
				default: 'Enable input',
			})}</Checkbox
		>
	{/if}
	<Checkbox id="enable-invert-input" size="m" bind:checked={settings.invert}
		>{$format('peripherals_enable_invert_input', {
			default: 'Enable invert input',
		})}</Checkbox
	>
	<Alert
		type="info"
		isHeadingBold
		heading={$format('label_info')}
		message={$format('alert_message_invert_digital_input_invert_info', {
			default:
				'For the change to be applied, the physical switch has to be toggled once after invert is set.',
		})}
	/>
</div>
